import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

/** Shows and hides a block of content with a trigger that says whether it is open. */
const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
